module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.user && this.$store.state.user.is_admin) ? _c('div', [_c('h1', [_vm._v("New Comic")]), _vm._v(" "), (_vm.message) ? _c('p', [_vm._v("Message: " + _vm._s(_vm.message))]) : _vm._e(), _vm._v("\n  Last Comic ID:"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastComicId),
      expression: "lastComicId"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.lastComicId)
    },
    on: {
      "change": _vm.getSuggestions,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastComicId = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" Selected: #" + _vm._s(_vm.selectedSuggestion) + "\n  "), _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('div', {
      class: {
        'suggestion': true,
        'selectedSuggestion': _vm.selectedSuggestion === suggestion.pk_post_id
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "radio"
      },
      domProps: {
        "value": suggestion.pk_post_id,
        "checked": _vm.selectedSuggestion === suggestion.pk_post_id
      },
      on: {
        "click": function($event) {
          _vm.selectedSuggestion = $event.target.value
        }
      }
    }), _vm._v("\n    #" + _vm._s(suggestion.pk_post_id) + "\n    [" + _vm._s(suggestion.votes) + " votes]\n    " + _vm._s(suggestion.username)), _c('br'), _vm._v("\n    " + _vm._s(suggestion.text) + "\n  ")])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.isSaving) ? _c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n        Drag your file(s) here to begin"), _c('br'), _vm._v(" or click to browse\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n        Uploading " + _vm._s(_vm.fileCount) + " files...\n      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.uploadedFiles.length === 0) ? _c('p', [_vm._v("[Uploaded images will appear here]")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.uploadedFiles), function(file) {
    return _c('div', {
      staticClass: "uploaded"
    }, [_c('p', [_vm._v(_vm._s(_vm.replaceURL(file)))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": file
      }
    })])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "text u-full-width",
    attrs: {
      "placeholder": "Write your draft elsewhere and paste in -- there's no draft functionality here!"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.content) ? _c('p', [_vm._v("[Preview will appear here]")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contents",
    domProps: {
      "innerHTML": _vm._s(_vm.content.split('./comics').join(_vm.api + '/comics'))
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Unlock:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unlock),
      expression: "unlock"
    }],
    staticClass: "u-full-width",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.unlock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.unlock = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lock:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lock),
      expression: "lock"
    }],
    staticClass: "u-full-width",
    attrs: {
      "type": "datetime-local"
    },
    domProps: {
      "value": (_vm.lock)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lock = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "note u-full-width",
    attrs: {
      "placeholder": "Note to the users (optional)"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.createComic
    }
  }, [_vm._v("Upload Comic")]), _vm._v(" "), (_vm.message) ? _c('p', [_vm._v("Message: " + _vm._s(_vm.message))]) : _vm._e()], 2) : _c('div', [_c('p', [_vm._v("Nope")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f210230"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Upload.vue
// module id = 280
// module chunks = 1